"use client";
import ErrorPage from "@/features/auth/pages/ErrorPage.page";

export default ErrorPage;
